import React from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

import { createSlug } from 'src/lib/createSlug';
import { useFetch } from 'src/lib/FetchContext';

import { ContentContainer } from '@riac/design-system';
import { CallToAction } from '@riac/design-system';
import { Gallery } from '@riac/design-system';
import { usePrefetchSuspense } from 'src/lib/usePrefetch';
import { MarkdownContentArea } from '@riac/design-system';
import { Content } from '@riac/design-system';
import { Breadcrumb } from '@riac/design-system';
import { SolidButton } from '@riac/design-system';
import { AuctionDate, AuctionDateContainer, AuctionDateStartDate } from 'src/components/AuctionDate/AuctionDate';
import { AuctionLocation } from '../AuctionsPage/AuctionsPage.style';
import styled from 'styled-components';


const AuctionsSinglePage = ({ history }): JSX.Element => {
  const { fetch } = useFetch();

  const auction = usePrefetchSuspense(`auctions-page-single-${history.location.pathname}`, async () => {
    const req = await fetch(`/api/auction/auctionBySlug/${history.location.pathname.split('/')[2]}`);
    const res = await req.json();
    return res[0];
  }).read();

  const gallery = usePrefetchSuspense(`auctions-page-single-gallery-${history.location.pathname}`, async () => {
    if(!auction) return;
    const req = await fetch(`/api/auction/auctionHighlights/${auction.AuctionID}`);
    const res = await req.json();
    return res;
  }).read();

  const previewDate = dayjs(auction.StartDate).subtract(1, 'day').format('dddd, MMM Do');
  let previewStartTime = '10:00 am'; // (auction.AuctionTypeID == 1) ? '10:00 am' : '9:00 am';
  let previewEndTime = '6:00 pm'
  let showPreview = auction.AuctionTypeID == 1 || auction.AuctionTypeID == 2;

  // <ONE TIME HACK REPLACE ME>
  if(auction.AuctionID == 2094) {
    auction.Subtitle = 'Guns & Coffee';
    previewStartTime = '11:00 am';
    previewEndTime = '4:00 pm';
    showPreview = true;
  }
  // </ONE TIME HACK REPLACE ME>

  return (
    <>
      <Breadcrumb
        content={[
          { slug: '/gun-auctions', text: 'Auctions' },
          { slug: `/gun-auctions/${createSlug(auction?.Title || '')}`, text: auction?.Title },
        ]}
      />
      <Content
        title={auction?.Title}
        as="h1"
      >
        {auction?.Subtitle
          && <h4>{auction.Subtitle}</h4>
        }
        <AuctionLocation>{`${auction?.LocCity}, ${auction?.LocState}`}</AuctionLocation>
        <AuctionDate
          auction={auction}
          startDateFormat="dddd MMMM Do"
          endDateFormat="dddd MMMM Do, YYYY"
          justifyContent={'center'}
          omitTime={auction.AuctionTypeID === TIMED_AUCTION_TYPE_ID}
        />
        {showPreview
          ? <AuctionDateStartDate>Preview Day: {previewDate} {previewStartTime} - {previewEndTime}</AuctionDateStartDate> : ''
        }
      </Content>
      <ContentContainer>
        {(gallery?.length > 0 && auction.CatalogSearchLink !== 1) && <Gallery items={gallery} />}
        <MarkdownContentArea
          dangerouslySetInnerHTML={{ __html: auction?.TextArea }}
          style={{ padding: '100px 0' }}
        />
      </ContentContainer>
      {auction?.CatalogSearchLink
        ? <CallToAction
          title='Ready to see more?'
          content={`Rock Island Auction Company is the global 
          leader in firearms auctions, currently holding multiple 
          records for our top-selling lots.`}
          button={<SolidButton to = {`/catalog/${auction?.AuctionID}`}>View Catalog</SolidButton>}
        />
        : null
      }
    </>
  );
};

export default AuctionsSinglePage;
